import { render } from "./Hits.vue?vue&type=template&id=5583748a"
import script from "./Hits.vue?vue&type=script&lang=js"
export * from "./Hits.vue?vue&type=script&lang=js"

import "./Hits.vue?vue&type=style&index=0&id=5583748a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__